import SolutionFinder from "./SolutionFinder";

export default SolutionFinder;



// WEBPACK FOOTER //
// ./js/components/SolutionFinder/index.js